var cacheVersion = "101";
var cachePrefix = "site";
export default {
  setCache: function setCache(cache_key, val) {
    window.localStorage.setItem(this.getCacheVersion(cache_key), val);
    return val;
  },
  getCache: function getCache(cache_key) {
    var split = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var val = window.localStorage.getItem(this.getCacheVersion(cache_key));
    console.log(val);
    if (split) {
      if (val) {
        return val.split(",");
      } else {
        return [];
      }
    }
    return val;
  },
  getCacheVersion: function getCacheVersion(cache_key) {
    console.log(cache_key + "_" + cacheVersion);
    return cachePrefix + "_" + cache_key + "_" + cacheVersion;
  }
};